import React, { useEffect, useState } from 'react';

import { theme } from '@breakroom-nx/assets';
import { VStack, Heading, Text } from 'native-base';
import { PrimaryButton } from '../../buttons/primary-button/primary-button';
import { useAppDispatch, flipToPane } from '@breakroom-nx/redux';
import { UserAvatar } from '../../user/user-avatar/user-avatar';
import { firestore } from '@breakroom-nx/apis';
import { doc, getDoc } from 'firebase/firestore';

/* eslint-disable-next-line */
export interface InvitePanelProps {
  invitee?: string;
}

export function InvitePanel({ invitee }: InvitePanelProps) {
  const dispatch = useAppDispatch();

  const [inviteeUID, setInviteeUID] = useState<string | undefined>(undefined);

  async function getUID() {
    if (invitee) {
      const userRef = doc(firestore, 'usernames', invitee);
      await getDoc(userRef)
        .then((snap) => {
          const data = snap.data();
          const uid = data?.uid as string;
          setInviteeUID(uid);
        })
        .catch(() => {
          setInviteeUID(undefined);
        });
    }
  }

  useEffect(() => {
    getUID();
  }, []);

  if (invitee && inviteeUID) {
    return (
      <VStack
        width={'full'}
        alignItems={'stretch'}
        textAlign={'center'}
        space={5}
        mt={5}
      >
        <UserAvatar uid={inviteeUID} disabled />
        <VStack my={5} space={3}>
          <Heading
            fontSize={30}
            lineHeight={34}
            color={theme.colors.yellow[300]}
          >
            {`You've been invited!`}
          </Heading>
          <Text color={theme.colors.surface[500]}>
            <Text color={theme.colors.primary[400]}>{invitee}</Text>
            {` is excited for you to join this platform, so are we!`}
          </Text>
        </VStack>
        <PrimaryButton
          text={'Sign Up'}
          onPress={() => {
            dispatch(flipToPane('Signup'));
          }}
        />
      </VStack>
    );
  } else {
    return null;
  }
}
